import React from 'react';
import { Link } from 'react-router-dom';
import './Hero.css';
import { useLanguage } from '../contexts/LanguageContext';
import { GiftIcon } from './Icons';
import BusinessTypesSlider from './BusinessTypesSlider';

const Hero = () => {
  const { t } = useLanguage();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="hero">
      <div className="hero-background-decoration"></div>
      <div className="hero-slider-section">
        <BusinessTypesSlider />
      </div>
      <div className="hero-container">
        <div className="hero-content">
          <Link to="/contact" className="hero-badge" aria-label={t('btnRequestDemo')}>
            <GiftIcon size={18} />
            <span>{t('heroDemoBadge')}</span>
          </Link>
          <h1 className="hero-title">
            {t('heroTitle')}
          </h1>
          <p className="hero-subtitle">
            {t('heroSubtitle')}
          </p>
          <div className="hero-demo-info">
            <div className="demo-highlight">
              <span className="demo-days">{t('demoDays')}</span>
              <span className="demo-text">{t('demoFree')}</span>
            </div>
            <p className="demo-description">{t('demoDescription')}</p>
          </div>
          <div className="hero-actions">
            <Link to="/contact" className="btn-primary btn-large">
              {t('btnRequestDemo')}
            </Link>
            <button className="btn-secondary btn-large" onClick={() => scrollToSection('features')}>
              {t('btnViewFeatures')}
            </button>
          </div>
        </div>
        <div className="hero-visual">
          <div className="premium-dashboard">
            <div className="dashboard-glow"></div>
            <div className="dashboard-main">
              <div className="dashboard-header">
                <div className="header-dots">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
                <div className="header-title">{t('dashboardTitle')}</div>
              </div>
              <div className="dashboard-content">
                <div className="metric-card floating-card-1">
                  <div className="metric-header">
                    <div className="metric-icon-wrapper">
                      <div className="metric-icon"></div>
                    </div>
                    <div className="metric-trend up">+12.5%</div>
                  </div>
                  <div className="metric-value">$24.5K</div>
                  <div className="metric-label">{t('dashboardRevenue')}</div>
                </div>
                <div className="metric-card floating-card-2">
                  <div className="metric-header">
                    <div className="metric-icon-wrapper">
                      <div className="metric-icon"></div>
                    </div>
                    <div className="metric-trend up">+8.2%</div>
                  </div>
                  <div className="metric-value">1,234</div>
                  <div className="metric-label">{t('dashboardOrders')}</div>
                </div>
                <div className="chart-container floating-card-3">
                  <div className="chart-header">{t('dashboardSalesOverview')}</div>
                  <div className="chart-bars">
                    <div className="bar" style={{ height: '65%' }}></div>
                    <div className="bar" style={{ height: '85%' }}></div>
                    <div className="bar" style={{ height: '50%' }}></div>
                    <div className="bar" style={{ height: '95%' }}></div>
                    <div className="bar" style={{ height: '75%' }}></div>
                    <div className="bar" style={{ height: '60%' }}></div>
                    <div className="bar" style={{ height: '90%' }}></div>
                  </div>
                </div>
                <div className="activity-list floating-card-4">
                  <div className="activity-item">
                    <div className="activity-dot"></div>
                    <div className="activity-content">
                      <div className="activity-title">{t('dashboardNewOrder')}</div>
                      <div className="activity-time">2 {t('dashboardMinAgo')}</div>
                    </div>
                  </div>
                  <div className="activity-item">
                    <div className="activity-dot"></div>
                    <div className="activity-content">
                      <div className="activity-title">{t('dashboardPaymentReceived')}</div>
                      <div className="activity-time">5 {t('dashboardMinAgo')}</div>
                    </div>
                  </div>
                  <div className="activity-item">
                    <div className="activity-dot"></div>
                    <div className="activity-content">
                      <div className="activity-title">{t('dashboardStockUpdated')}</div>
                      <div className="activity-time">10 {t('dashboardMinAgo')}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="dashboard-decoration">
              <div className="decoration-circle circle-1"></div>
              <div className="decoration-circle circle-2"></div>
              <div className="decoration-circle circle-3"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;

